module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<li class="issue-' +
((__t = ( window.issue_depth(main.get('code')) )) == null ? '' : __t) +
' ' +
((__t = ( {true: 'current'}[last] )) == null ? '' : __t) +
' ';
 if (last) { ;
__p +=
((__t = ( changeClass(main.get('net_allocated'), main.get('net_revised')) )) == null ? '' : __t);
 } ;
__p += '">\n\n  ';
 if(last) { ;
__p += '\n    <div id="affix-wrapper">\n    <header id="affix-header" data-spy="affix" data-offset-top="174">\n    <div class="issue-part"></div>\n  ';
 } ;
__p += '\n  <!-- Issue number -->\n  <div class="issue-num pull-right">\n    ' +
((__t = ( main.get('code').slice(2).replace(/(.{2})(?!$)/g , '$1.') )) == null ? '' : __t) +
'\n  </div>\n  <!-- Issue title -->\n  <div class="pull-right">\n    ' +
((__t = ( last ? '<h1>' : '<h3>' )) == null ? '' : __t) +
'\n      <a class="dropdown-toggle" href="' +
((__t = ( window.URLSchemeHandlerInstance.linkToBudget(main.get('code'),main.get('year')) )) == null ? '' : __t) +
'">\n        ' +
((__t = ( main.get('title') )) == null ? '' : __t) +
'</a>\n\n        <span class="dropdown">\n           <a href="#" data-toggle="dropdown" class="dropdown-toggle"><span class="caret"></span></a>\n          <ul class="dropdown-menu" role="menu">\n            ';
 for ( var _kid in kids.models ) { var kid=kids.models[_kid];  ;
__p += '\n                <li><a href="' +
((__t = ( window.URLSchemeHandlerInstance.linkToBudget(kid.get('code'),main.get('year')) )) == null ? '' : __t) +
'">#' +
((__t = ( kid.get('code').slice(2) )) == null ? '' : __t) +
'  - ' +
((__t = ( kid.get('title'))) == null ? '' : __t) +
'</a></li>\n            ';
 } ;
__p += '\n          </ul>\n        </span>\n\n        /\n    ' +
((__t = ( last ? '</h1>' : '</h3>' )) == null ? '' : __t) +
'\n\n\n  </div>\n  <div class="item-budget pull-left">\n    ₪\n    ' +
((__t = ( window.number_with_commas(main.get('net_revised')*1000) )) == null ? '' : __t) +
'\n    ' +
((__t = ( window.up_or_down_arrow(main.get('net_revised'), main.get('net_allocated')) )) == null ? '' : __t) +
'\n  </div>\n  ';
 if(last) { ;
__p += '\n  <div class="pull-left">\n    <span class="dropdown">\n      <a class="btn btn-default btn-sm btn-download" href="#"\n      data-toggle="dropdown">\n        <i class="glyphicon glyphicon-download-alt"></i>\n      </a>\n          <ul class="dropdown-menu" role="menu">\n              <li>\n                  <strong>\n                      הורדת נתונים לקובץ CSV\n                  </strong>\n              </li>\n              <li>\n        <a target="_blank"\n           href="http://www.obudget.org/api/budget/' +
((__t = ( main.get('code') )) == null ? '' : __t) +
'?o=xls&amp;limit=10000">\n          הסטוריה תקציבית\n        </a>\n              </li>\n            <li>\n      <a target="_blank"\n         href="http://www.obudget.org/api/exemption/budget/' +
((__t = ( main.get('code') )) == null ? '' : __t) +
'?o=xls&amp;limit=10000">\n        פטורים ממכרז\n      </a>\n            </li>\n            <li>\n      <a target="_blank"\n         href="http://www.obudget.org/api/supports/' +
((__t = ( main.get('code') )) == null ? '' : __t) +
'?o=xls&amp;limit=10000">\n        תמיכות\n      </a>\n            </li>\n          </ul>\n        </span>\n\n  </div>\n  ';
 } ;
__p += '\n  ';
 if(last) { ;
__p += '\n    </header>\n    </div>\n    <section class="brief container">\n      <div class="spinner">\n        <div class="rect1"></div>\n        <div class="rect2"></div>\n        <div class="rect3"></div>\n        <div class="rect4"></div>\n        <div class="rect5"></div>\n      </div>\n    </section>\n  ';
 } ;
__p += '\n  <div class="issue-partition"></div>\n</li>\n';

}
return __p
};


//////////////////
// WEBPACK FOOTER
// ./app/templates/breadcrumb-item.html
// module id = 133
// module chunks = 0